import { z } from 'zod';
import { nameSchema, phoneSchema, emailSchema, objectIdSchema } from '../validation';

export const businessPersonTypeSchema = z.enum([
  'owner',
  'manager',
  'logistics_manger',
  'employee',
  'driver',
  'other',
]);

export type ContactPersonType = z.infer<typeof businessPersonTypeSchema>;

export const contactPersonSchema = z.object({
  /** the name of the person to contact with */
  name: nameSchema,
  /** the type of the person to contact with */
  personType: businessPersonTypeSchema,
  /** the phone number of the person to contact with */
  phone: phoneSchema,
  /** the email of the person to contact with */
  email: emailSchema.optional(),
});
export type ContactPerson = z.infer<typeof businessPersonTypeSchema>;

/** this is used for contact sharing between collections such as `Customer` and `Contact` */
export const contactSharedSchema = contactPersonSchema.extend({
  /** the _id of the contact coming from `Contact` Collection */
  _id: objectIdSchema,
  /** if this is true, then this is the primary contact person for the customer */
  isPrimary: z.boolean(),
});
export type ContactShared = z.infer<typeof contactSharedSchema>;
